import moment from 'moment';
import { DateTimePipe } from 'src/app/shared/pipes/date-time.pipe';

function capitalize(str: string | undefined | null): string {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function statusColor(status: any) {
  let statusWiseColor: any = '';
  switch (status) {
    case 'Moving':
      statusWiseColor = '#1FBE62';
      break;
    case 'Stop':
      statusWiseColor = '#CF1945';
      break;
    case 'Charging':
      statusWiseColor = '#0892D0';
      break;
    case 'Offline':
      statusWiseColor = '#505050';
      break;
    case 'Breakdown':
      statusWiseColor = '#E74C3C';
      break;
    case 'Accident':
      statusWiseColor = '#FF8C00';
      break;
    case 'Idle':
      statusWiseColor = '#9B59B6';
      break;
    case 'PTO':
      statusWiseColor = '#154F55';
      break;
    case 'Service':
      statusWiseColor = '#ff6982';
      break;
    default:
      statusWiseColor = '#1FBE62';
  }
  return statusWiseColor;
}

export function batteryColor(battery: any) {
  let color: any = battery / 10;
  if (battery < 3) {
    color = '#CF1945';
  } else if (battery == 3) {
    color = '#FF9900';
  } else if (battery > 3) {
    color = '#1FBE62';
  }

  return color;
}

export function infoWindow(
  vehicleColor: any,
  data: any,
  batteryColor: any,
  selectedVehicleType?: any,
  enableLiveTracking?: boolean,
  dealerCharger?: boolean,
  dateTimePipe2?: DateTimePipe
) {
  const soc: number = data?.soc / 10;

  const speed =
    data?.speed !== undefined && data?.speed != null
      ? `${data?.speed} km/h`
      : '-';
  let odometer = '0';
  let hourMeter = '0';

  function formatWithUnit(value: any, unit: string | undefined) {
    if (value === undefined || value === null || value === '') {
      return unit ? `- ${unit}` : '-';
    }
    return unit ? `${value} ${unit}` : value;
  }

  if (data?.odometer == undefined || data?.odometer == null) {
    odometer = formatWithUnit(data?.hourMeter?.value, data?.hourMeter?.unit);
  } else {
    const odometerValue =
      selectedVehicleType === 'Tractor'
        ? data?.odometer?.hmtr
        : data?.odometer?.value;

    odometer = formatWithUnit(odometerValue, data?.odometer?.unit);
  }
  const geo_lat = data?.latitude
    ? parseFloat((+data?.latitude).toFixed(6))
    : '-';
  const geo_long = data?.longitude
    ? parseFloat((+data?.longitude).toFixed(6))
    : '-';
  const latLng = `${geo_lat}, ${geo_long}`;

  const customDateLabel = data?.event_time ? 'Date' : 'Last Connected';

  const address = data?.address == 'latlng' ? latLng : data?.address;
  if (
    data?.hourMeter !== undefined &&
    data?.hourMeter != null &&
    data.variantCode === 'VC011'
  ) {
    hourMeter = formatWithUnit(data?.hourMeter?.value, data?.hourMeter?.unit);
  } else {
    hourMeter = formatWithUnit(data?.hourMeter?.value, data?.hourMeter?.unit);
  }

  const dateTimePipe = dateTimePipe2 ?? new DateTimePipe();
  const dateValue = data?.lastConnected || data?.event_time;
  const lastConnectedFormat =
    dateTimePipe.transform(dateValue, 'dateTime') ?? '-';

  let contentString =
    `
  <div style="width: 100%; height: 100%; min-height: 270px; display: flex; flex-direction: column; align-items: flex-start;">
  <div style="height: 40px; background: ` +
    vehicleColor +
    `; padding: 4px 11px; border-top-left-radius: 8px; border-top-right-radius: 8px; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 10px;">
      <div style="width: 220px; display: flex; justify-content: flex-start; align-items: center; gap: 174px;">
          <div style="display: flex; gap: 100px;">
              <div style="display: flex; justify-content: center; align-items: center;">
                  <div>
                      <span style="color: white; font-size: 11px; font-family: Inter; font-weight: 400; line-height: 16px; word-wrap: break-word;">Vehicle No</span><br>
                      <span style="color: white; font-size: 11px; font-family: Inter; font-weight: 600; line-height: 16px; word-wrap: break-word;">` +
    data.vehicleNumber +
    `</span>
                  </div>
              </div>
          </div>
      </div>
  </div>
  <div style="width: 223px; height: 138.25px; position: relative;">
      <div style="position: absolute; width: 100%; height: 100%;">
          <div ></div>
          <div style="position: absolute; width: 23.38px; height: 20.25px; left: 100px; top: 138.25px; background: white;"></div>
      </div>
      <div style="position: absolute; width: 230px; height: 97px; left: 10px; top: 10px; display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 8px;">
          <div style="display: flex">
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;width: 160px">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">` +
    customDateLabel +
    `</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word;"> ${lastConnectedFormat}` +
    `</div>
              </div>
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400;">Status</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word; padding-left: 1px;">` +
    data.status +
    `</div>
              </div>
          </div>
          <div style="display: flex; justify-content: space-between;">
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px; width: 160px;">
                 <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">
  ` +
    (capitalize(data?.odometer?.name) || data?.hourMeter?.name) +
    `
</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-break: break-all;">` +
    odometer +
    `</div>
              </div>
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px; word-break: break-all;">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">Speed</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; white-space: nowrap; word-break: break-all; padding-left: 1px;">` +
    speed +
    `</div>
              </div>
          </div>
          ` +
    (data?.hourMeter !== undefined &&
    data?.hourMeter != null &&
    data.variantCode === 'VC011'
      ? `
          <div style="display: flex; justify-content: space-between; width: 215px;">
              <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 3px;">
                  <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">` +
        data?.hourMeter?.name +
        `</div>
                  <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; white-space: nowrap; width: 75px; word-break: break-all; padding-left: 1px;">` +
        hourMeter +
        `</div>
              </div>
          </div>
  `
      : '') +
    `
          <div style="display: flex; gap: 30px;">
              <div style="display: flex; justify-content: flex-start; align-items: center; gap: 5px;">
                  <div style="position: relative; width: 83px; height: 18px;">
                      <div style="position: absolute; width: 100%; height: 100%; background: rgba(217, 217, 217, 0.05); border-radius: 4px; border: 0.7px #9F9F9F solid;"></div>
                      <div style="position: absolute; width: ` +
    soc * 8 +
    `; height: 14px; display: flex; justify-content: flex-start; align-items: flex-start; gap: 0.5px;margin-left:1px">
  `;

  let str = '';
  for (let index = 0; index < soc; index++) {
    let borderradius;
    if (index == 0) {
      borderradius = '3px 0 0 3px';
    } else if (index == 9) {
      borderradius = '0 3px 3px 0';
    }
    str =
      str +
      `<div style="width: 7px; height: 14px; background: ` +
      batteryColor +
      `; border-radius: ` +
      borderradius +
      `;
  margin-top: 2px;margin-left:0.5px"></div>`;
  }

  let xyz =
    `
                      </div>
                  </div>
                  <div style="display: flex; gap: 72px;">
                      <div style="color: ` +
    batteryColor +
    `; font-size: 8px; font-family: Inter; font-weight: 600; word-wrap: break-word;">` +
    soc * 10 +
    `% (SOC)</div>
                  </div>
              </div>
          </div>
     <div style="display: flex;">
    <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 4px;">
      <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">Address</div>
    <div 
      id="appLocationContainer" 
      class="limited-address-container"
    ></div> </div>
  </div>
        </div>
    </div>

    `;

  if (enableLiveTracking) {
    xyz +=
      `
    <div style="width: 100%;z-index: 1;padding: 10px;position: absolute;bottom: 0;">  
      <button style="width: 100%;padding: 5px 10px;border-radius: 4px;border: 1px solid #0892D0;color: #0892D0;background: #fff;" id="LiveTrackingButton` +
      data.vehicleCode +
      `" >Live Tracking</button>
    </div>
    `;
  }
  if (dealerCharger) {
    xyz +=
      `
          <div style="width: 100%;z-index: 1;padding: 10px;">  
          <div style="display: flex; justify-content: space-between; width: 215px;position: relative;top: 15px;">

      <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 5px;">
           <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400; word-wrap: break-word;">` +
      `Locate Dealer` +
      `</div>
            <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word;">
            <a href="javascript:void(0);"
            id="dealer"
          >View</a>
           </div>
        </div>
        <div style="display: flex; flex-direction: column; justify-content: flex-start; align-items: flex-start; gap: 1px;">
            <div style="color: #9F9F9F; font-size: 9px; font-family: Inter; font-weight: 400;">Locate Charger</div>
            <div style="color: #505050; font-size: 9px; font-family: Inter; font-weight: 600; word-wrap: break-word; padding-left: 1px;">
             <a href="javascript:void(0);" id="charger"
              >View</a>
            </div>
         </div>
      </div>
          </div>

    `;
  }

  contentString = contentString + str + xyz;
  return contentString;
}

export const MOCK_DURATION = [
  { name: 'Day', key: 'D' },
  { name: 'Hours', key: 'H' },
];

export const DAYS = [
  '1 Day',
  '2 Days',
  '3 Days',
  '4 Days',
  '5 Days',
  '6 Days',
  '7 Days',
];

export const HOURS = [
  '1 Hour',
  '2 Hours',
  '3 Hours',
  '4 Hours',
  '5 Hours',
  '6 Hours',
  '7 Hours',
  '8 Hours',
  '9 Hours',
  '10 Hours',
  '11 Hours',
  '12 Hours',
  '13 Hours',
  '14 Hours',
  '15 Hours',
  '16 Hours',
  '17 Hours',
  '18 Hours',
  '19 Hours',
  '20 Hours',
  '21 Hours',
  '22 Hours',
  '23 Hours',
];

export const lob = [
  { id: '1', code: 'VC01', name: 'Truck' },
  { id: '2', code: 'VC02', name: 'Tractor' },
  { id: '3', code: 'VC03', name: '3-Wheeler' },
  { id: '4', code: 'VC04', name: 'SCV' },
];

export function getAddress(lat: any, lng: any): Promise<string> {
  return new Promise((resolve, reject) => {
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat, lng };

    if (!google || !google.maps || !google.maps.Geocoder) {
      reject('Google Maps API not loaded');
      return;
    }

    geocoder.geocode({ location: latlng }, (results: any, status) => {
      if (status === 'OK' && results[0]) {
        resolve(results[0].formatted_address);
      } else {
        resolve('No address found');
      }
    });
  });
}

export const allVariants = [
  'VC001',
  'VC007',
  'VC008',
  'VC009',
  'VC011',
  'VC010',
  'EVE350XFSDV2',
  'VC004',
  'VC003',
  'VC005',
  'VC017',
  'VC018',
  'VC120',
  'VC006',
  'VC020',
  'VC021',
  'VC025',
  'VC026',
];
